if (!customElements.get('jupityr-session-progress')) {
  customElements.define('jupityr-session-progress', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.controller = new AbortController();
      const options = { signal:this.controller.signal };
      const perDay = Number(this.dataset.sessionsPerDay);
      const total = Number(this.dataset.days) * perDay;
      let sessions = 0, speed = 1, elapsed = 0;
      let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      let visible = false;
      const pause = this.querySelector('[data-progress-pause]');
      const speedButtons = this.querySelectorAll('[data-progress-speed]');
      const status = this.querySelector('[data-progress-status]');
      const render = () => {
        this.querySelector('[data-session-count]').textContent = sessions;
        this.querySelector('[data-session-day]').textContent = `Day ${Math.min(Number(this.dataset.days), Math.floor(sessions / perDay))}`;
        this.querySelectorAll('[data-demo-percent]').forEach(milestone => {
          const percent = Math.round(sessions / total * Number(milestone.dataset.demoPercent));
          milestone.querySelector('[data-milestone-percent]').textContent = `${percent}%`;
          milestone.querySelector('circle.jupityr-session-progress__arc').style.strokeDashoffset = 100 - percent;
        });
        pause.querySelector('[data-progress-pause-label]').textContent = sessions === total ? 'Replay' : paused ? 'Resume' : 'Pause';
        pause.dataset.paused = String(paused);
        speedButtons.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.progressSpeed) === speed)));
      };
      pause.addEventListener('click', () => {
        if (sessions === total) { sessions = 0; elapsed = 0; }
        paused = !paused; render(); status.textContent = paused ? `Paused at ${sessions} sessions.` : 'Animation resumed.';
      }, options);
      speedButtons.forEach(button => button.addEventListener('click', () => { speed = Number(button.dataset.progressSpeed); render(); status.textContent = `Animation speed ${speed} times.`; }, options));
      this.querySelector('[data-progress-restart]').addEventListener('click', () => { sessions = 0; elapsed = 0; speed = 1; paused = matchMedia('(prefers-reduced-motion: reduce)').matches; render(); status.textContent = 'Routine restarted at zero sessions.'; }, options);
      this.observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, {threshold:.15});
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (paused || !visible || document.hidden) return;
        elapsed += 100 * speed;
        if (elapsed < 800) return;
        sessions = Math.min(total, sessions + Math.floor(elapsed / 800)); elapsed %= 800;
        if (sessions === total) { paused = true; status.textContent = `Routine complete: ${total} brushing sessions.`; }
        render();
      }, 100);
      render();
    }
    cleanup() { this.controller?.abort(); this.observer?.disconnect(); clearInterval(this.timer); }
    disconnectedCallback() { this.cleanup(); }
  });
}
